import { EFactsheetClasses } from './EFactsheetClasses';

export const EAppType = {
  Development: 'development',
  Calculator: 'calculator',
  SectorPerformance: 'sector-performance',
  FactsheetUsAmericanStocks: `factsheet-${EFactsheetClasses.US_AMERICAN_STOCKS}`,
  PortfolioManagementEvent: 'portfolio-management-events-tab',
  PortfolioManagementMiscellaneous: 'portfolio-management-miscellaneous-tab',
  PortfolioManagementPerformance: 'portfolio-management-performance-tab',
  PortfolioManagementHedge: 'portfolio-management-hedge-tab'
} as const;

export type EAppTypeValue = (typeof EAppType)[keyof typeof EAppType] | string;
